import * as React from "react"
import __ from "lodash"
import { withTranslation } from "react-i18next"
import { Grid, GridColumn } from "@atlaskit/page"
import { CardFrame } from "@atlaskit/media-ui"
import CardFrameContent from "../../../../partials/CardFrameContent"
import { IBaseProps } from "../../../../../utils/BaseProps"
import { Ticket_ticket_eagWaste as Specifics } from "../../../../../api/graphql/queries/types/Ticket"
import Headline from "../../partials/Headline"
import ShowText from "../../fields/ShowText"
import ShowBoolean from "../../fields/ShowBoolean"

interface IEagWasteProps extends IBaseProps {
  specifics: Specifics
}
  
interface IEagWasteState {
    
}
  
class EagWaste extends React.Component<IEagWasteProps, IEagWasteState> {
  state: IEagWasteState
  
  constructor(props: IEagWasteProps) {
    super(props)

    this.state = {
    }
  }
  
  private renderCompanyAndProcess() {
    const { t, specifics } = this.props
    return (
      <React.Fragment>
        <GridColumn medium={12}>
          <Headline>{t('company_process')}</Headline>
        </GridColumn>
        <GridColumn medium={6}>
          <ShowText name="production" translation="tickets.fields.company_process.production" value={specifics.production} />
        </GridColumn>
        <GridColumn medium={6}>
          <ShowText name="process" translation="tickets.fields.company_process.process" value={specifics.process} />
        </GridColumn>
        <GridColumn medium={6}>
          <ShowText name="usage" translation="tickets.fields.company_process.usage" value={specifics.usage} />
        </GridColumn>
        <GridColumn medium={6}>
          <ShowBoolean name="container_available" translation="tickets.fields.company_process.container_available" value={specifics.isContainerAvailable} />
        </GridColumn>
      </React.Fragment>
    )
  }
  
  private renderMaterialDescription() {
    const { t, specifics } = this.props
    return (
      <React.Fragment>
        <GridColumn medium={12}>
          <Headline>{t('material_description')}</Headline>
        </GridColumn>
        <GridColumn medium={6}>
          <ShowBoolean name="foreign_substance" translation="tickets.fields.material_description.foreign_substance" value={specifics.hasForeignSubstance} />
        </GridColumn>
        <GridColumn medium={6}>
          <ShowText name="foreign_substance_additional" translation="tickets.fields.material_description.foreign_substance_additional" value={specifics.hasForeignSubstanceAdditional} />
        </GridColumn>
        <GridColumn medium={12}>
          <ShowText name="waste_from" translation="tickets.fields.material_description.waste_from" value={t(`waste_from.code.${specifics.wasteFrom}`)} />
        </GridColumn>
      </React.Fragment>
    )
  }

  private renderAdditional() {
    const { t, specifics } = this.props
    return (
      <React.Fragment>
        <GridColumn medium={12}>
          <Headline>{t('additional')}</Headline>
        </GridColumn>
        <GridColumn medium={6}>
          <ShowText name="comment" translation="tickets.fields.material_description.comment" value={specifics.comment} />
        </GridColumn>
      </React.Fragment>
    )
  }

  public render() {
    const { t, specifics } = this.props
    console.log(specifics)
    return (
      <CardFrame text={t('tickets.create.fields.eag.title')}>
        <CardFrameContent>
          <Grid layout="max-width">
            <GridColumn medium={12}>
              <Headline>{t('generic')}</Headline>
            </GridColumn>
            <GridColumn medium={6}>
              <ShowText name="waste_description" translation="tickets.create.fields.waste_description" value={specifics.description} />
            </GridColumn>
            {this.renderCompanyAndProcess()}
            {this.renderMaterialDescription()}
            {this.renderAdditional()}
          </Grid>
        </CardFrameContent>
      </CardFrame>
    )
  }
}

export default withTranslation()(EagWaste)
